module.exports = __webpack_public_path__ + "assets/img/f245b3e0c508a53e854dc93f229c03a7.png";